export default __webpack_public_path__ + "static/media/app-reqreceived.b90bfb71.png";